<template>
    <div ref="animationContainer" :style="{ width: width + 'px', height: height + 'px' }"></div>
</template>

<script>
    import Lottie from 'Lottie-web'

    export default {
        name: 'sm-lottie',
        props: {
            filename: {
                type: String,
                required: true,
            },
            width: {
                type: String,
                default: '400',
            },
            height: {
                type: String,
                default: '400',
            },
        },
        mounted() {
            this.loadAnimation()
        },
        methods: {
            loadAnimation() {
                Lottie.loadAnimation({
                    container: this.$refs.animationContainer,
                    renderer: 'svg',
                    loop: true,
                    autoplay: true,
                    path: '/lotties/' + this.filename,
                })
            },
        },
    }
</script>

<style scoped>
    div {
        width: 100%;
        height: 100%;
    }
</style>
